/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { GetDrawLayerFeaturesByBbox200Response } from '../models';
/**
 * DrawLayerApi - axios parameter creator
 */
export const DrawLayerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List all features within a bbox for draw layers
         * @summary List features within bbox
         * @param {number} minLongitude 
         * @param {number} minLatitude 
         * @param {number} maxLongitude 
         * @param {number} maxLatitude 
         * @param {string} operationId 
         * @param {Array<string>} [drawLayerIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawLayerFeaturesByBbox: async (minLongitude: number, minLatitude: number, maxLongitude: number, maxLatitude: number, operationId: string, drawLayerIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'minLongitude' is not null or undefined
            assertParamExists('getDrawLayerFeaturesByBbox', 'minLongitude', minLongitude)
            // verify required parameter 'minLatitude' is not null or undefined
            assertParamExists('getDrawLayerFeaturesByBbox', 'minLatitude', minLatitude)
            // verify required parameter 'maxLongitude' is not null or undefined
            assertParamExists('getDrawLayerFeaturesByBbox', 'maxLongitude', maxLongitude)
            // verify required parameter 'maxLatitude' is not null or undefined
            assertParamExists('getDrawLayerFeaturesByBbox', 'maxLatitude', maxLatitude)
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('getDrawLayerFeaturesByBbox', 'operationId', operationId)
            const localVarPath = `/api/nora/draw-layer/bbox`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (drawLayerIds) {
                localVarQueryParameter['drawLayerIds'] = drawLayerIds;
            }

            if (minLongitude !== undefined) {
                localVarQueryParameter['minLongitude'] = minLongitude;
            }

            if (minLatitude !== undefined) {
                localVarQueryParameter['minLatitude'] = minLatitude;
            }

            if (maxLongitude !== undefined) {
                localVarQueryParameter['maxLongitude'] = maxLongitude;
            }

            if (maxLatitude !== undefined) {
                localVarQueryParameter['maxLatitude'] = maxLatitude;
            }

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DrawLayerApi - functional programming interface
 */
export const DrawLayerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DrawLayerApiAxiosParamCreator(configuration)
    return {
        /**
         * List all features within a bbox for draw layers
         * @summary List features within bbox
         * @param {number} minLongitude 
         * @param {number} minLatitude 
         * @param {number} maxLongitude 
         * @param {number} maxLatitude 
         * @param {string} operationId 
         * @param {Array<string>} [drawLayerIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDrawLayerFeaturesByBbox(minLongitude: number, minLatitude: number, maxLongitude: number, maxLatitude: number, operationId: string, drawLayerIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDrawLayerFeaturesByBbox200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDrawLayerFeaturesByBbox(minLongitude, minLatitude, maxLongitude, maxLatitude, operationId, drawLayerIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DrawLayerApi.getDrawLayerFeaturesByBbox']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DrawLayerApi - factory interface
 */
export const DrawLayerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DrawLayerApiFp(configuration)
    return {
        /**
         * List all features within a bbox for draw layers
         * @summary List features within bbox
         * @param {DrawLayerApiGetDrawLayerFeaturesByBboxRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDrawLayerFeaturesByBbox(requestParameters: DrawLayerApiGetDrawLayerFeaturesByBboxRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetDrawLayerFeaturesByBbox200Response> {
            return localVarFp.getDrawLayerFeaturesByBbox(requestParameters.minLongitude, requestParameters.minLatitude, requestParameters.maxLongitude, requestParameters.maxLatitude, requestParameters.operationId, requestParameters.drawLayerIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getDrawLayerFeaturesByBbox operation in DrawLayerApi.
 */
export interface DrawLayerApiGetDrawLayerFeaturesByBboxRequest {
    readonly minLongitude: number

    readonly minLatitude: number

    readonly maxLongitude: number

    readonly maxLatitude: number

    readonly operationId: string

    readonly drawLayerIds?: Array<string>
}

/**
 * DrawLayerApi - object-oriented interface
 */
export class DrawLayerApi extends BaseAPI {
    /**
     * List all features within a bbox for draw layers
     * @summary List features within bbox
     * @param {DrawLayerApiGetDrawLayerFeaturesByBboxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDrawLayerFeaturesByBbox(requestParameters: DrawLayerApiGetDrawLayerFeaturesByBboxRequest, options?: RawAxiosRequestConfig) {
        return DrawLayerApiFp(this.configuration).getDrawLayerFeaturesByBbox(requestParameters.minLongitude, requestParameters.minLatitude, requestParameters.maxLongitude, requestParameters.maxLatitude, requestParameters.operationId, requestParameters.drawLayerIds, options).then((request) => request(this.axios, this.basePath));
    }
}

